<template>
  <div class="scale-wrapper">
    <Row class="wrapper"
         :key="key">
      <i-col :span="7"
             class="box-wrapper h">
        <v-chart theme="westeros"
                 :options="monthSaleOptions(sales_by_month)"
                 width="100%"
                 height="100%" />
      </i-col>
      <i-col :span="10"
             class="flex-column h">
        <div class="brief">
          <div>
            <ICountUp v-if="shops_count"
                      :delay="1000"
                      :endVal="shops_count.value" />
            <label>连锁店总数</label>
          </div>
          <div>
            <ICountUp v-if="today_sales_count"
                      :delay="1000"
                      :endVal="today_sales_count.value" />
            <label>今日销售额</label>
          </div>
          <div>
            <ICountUp v-if="today_orders_count"
                      :delay="1000"
                      :endVal="today_orders_count.value" />
            <label>今日订单数</label>
          </div>
        </div>
        <div class="map">
          <div class="bg" />
          <v-chart theme="westeros"
                   :options="mapOptions(shops_maps)"
                   width="100%"
                   height="100%" />
        </div>
        <div class="summary-table">
          <div class="head">
            <table>
              <colgroup>
                <col align="left"
                     width="50%" />
                <col width="15%" />
                <col width="15%" />
                <col />
              </colgroup>
              <thead>
                <tr>
                  <th>店名</th>
                  <th>销量</th>
                  <th>会员数量</th>
                  <th>商品数量</th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table"
               ref="table">
            <table style="flex: unset">
              <colgroup>
                <col align="left"
                     width="50%" />
                <col width="15%" />
                <col width="15%" />
                <col />
              </colgroup>
              <tbody>
                <tr v-for="item in shops_summary"
                    :key="item.shop_name">
                  <td>{{ item.shop_name }}</td>
                  <td>{{ item.sales }}</td>
                  <td>{{ item.customers_count }}</td>
                  <td>{{ item.products_count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </i-col>
      <i-col class="right"
             :span="7">
        <div>
          <v-chart theme="westeros"
                   :options="salesTrendOptions(sales_trend_by_month)"
                   width="100%"
                   height="100%" />
        </div>
        <div>
          <v-chart theme="westeros"
                   :options="paymentOptions(sales_payment_methods)"
                   width="100%"
                   height="100%" />
        </div>
        <div class="order-count">
          <v-chart theme="westeros"
                   :options="orderCountOptions(orders_count_by_month)"
                   width="100%"
                   height="100%" />
        </div>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import monthSaleOptions from './options/month-sales'
import orderCountOptions from './options/order-count'
import salesTrendOptions from './options/sales-trend'
import paymentOptions from './options/payment'
import mapOptions from './options/map'
import ICountUp from 'vue-countup-v2'

function delay (t) {
  return new Promise((resolve) => {
    setTimeout(resolve, t)
  })
}

export default {
  name: 'Statistics',
  components: {
    ICountUp
  },
  data () {
    return {
      key: Date.now()
    }
  },
  computed: {
    ...mapState('dashboard', [
      'sales_by_month',
      'orders_count_by_month',
      'shops_count',
      'today_sales_count',
      'today_orders_count',
      'shops_summary',
      'sales_trend_by_month',
      'sales_payment_methods',
      'shops_maps'
    ])
  },
  mounted () {
    this.fetchDashBoardData()
    window.addEventListener('resize', this.onResize)
    this.polling = setInterval(() => {
      this.fetchDashBoardData()
    }, 60 * 1000)
    this.tableScroll = setInterval(() => {
      this.checkTableScroll()
    }, 10000)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
    window.clearInterval(this.polling)
    window.clearInterval(this.tableScroll)
  },
  methods: {
    ...mapActions('dashboard', ['fetchDashBoardData']),
    monthSaleOptions,
    orderCountOptions,
    salesTrendOptions,
    paymentOptions,
    mapOptions,
    onResize () {
      this.key = Date.now()
    },
    async checkTableScroll () {
      console.log('checkTableScroll')
      const $table = this.$refs.table
      let stop = false
      for (let i = 0; i < $table.clientHeight && !stop; i++) {
        const scrollHeight = $table.scrollHeight
        const curr = $table.scrollTop + $table.clientHeight
        if (scrollHeight - curr > 10) {
          $table.scrollBy(0, 1)
          await delay(16)
        } else if (i === 0) {
          $table.scrollTo({
            top: 0,
            behavior: 'smooth'
          })
          stop = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.scale-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.wrapper {
  width: 200%;
  height: 200%;
  transform: scale(0.5);
  transform-origin: left top;
  background: #01123a;
  display: block;
  box-sizing: border-box;
  padding: 20px;
}

.box-wrapper {
  padding: 12px;
  border: 1px solid #666;
  border-radius: 4px;
  > div {
    width: 100%;
    height: 100%;
  }
}

.brief {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 30px 40px;
  border: 1px solid #f5f5f5;
  border-radius: 40px;
  margin: 20px;
  padding-bottom: 60px;
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: center;
    > span {
      font-size: 100px;
      color: #f5f5f5;
      font-weight: bold;
    }
    label {
      font-size: 30px;
      color: #999;
      font-weight: bold;
    }
  }
}

.map {
  height: 100vh;
  flex: 0 0 100vh;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  position: relative;
  .echarts {
    flex: auto;
    height: 100%;
  }
}

.summary-table {
  padding: 5px 20px;
  width: 100%;
  height: calc(60vh - 300px);
  flex: auto;
  flex-direction: column;
  display: flex;
  font-size: 28px;
  font-weight: 500;
  table {
    flex: auto;
    width: 100%;
    border-collapse: collapse;
    thead {
      border: 1px solid #999;
    }
    tbody {
      overflow: auto;
    }
    tr {
      border-bottom: 1px solid #666;
      td,
      th {
        text-align: left;
        padding: 8px 10px;
        &:nth-of-type(1) {
          width: 100px;
        }
      }
      td {
        color: #ccc;
      }
      th {
        font-weight: bold;
        color: #aaa;
      }
    }
  }
  .head {
    flex: 0 0 auto;
  }
  .table {
    flex: auto;
    overflow: auto;
    border: 1px solid #999;
  }
}

.h {
  height: 100%;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.right {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > div {
    // flex: 0 0 26vh;
    height: calc(33% - 10px);
    border: 1px solid #999;
    padding: 12px;
    &:nth-of-type(n + 2) {
      // margin-top: 5px;
    }
    > div {
      height: 100%;
      width: 100%;
    }
  }
}

.order-count {
  display: flex;
  > div {
    height: 100%;
    flex: auto;
  }
}

.bg {
  width: 100%;
  height: 100%;
  background: rgba(19, 110, 255, 0.5);
  z-index: -1;
  position: absolute;
  filter: blur(200px);
  border-radius: 50%;
  animation: scale 12s ease 1s infinite both;
}

@keyframes scale {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
